import React from 'react';
import { CopyIcon } from '../../../../../../components/icons/Copy';
import styled from '@emotion/styled';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useState } from 'react';
import { useEffect } from 'react';

const CartaoLink = ({ pacienteId }) => {
  const [linkPagamentoCopiado, setLinkPagamentoCopiado] = useState(false);
  const [urlPagamentoVenda, setUrlPagamentoVenda] = useState('');

  useEffect(() => {
    const newURL =
      window.location.protocol +
      '//' +
      window.location.host +
      '/pagamento-plano/' +
      pacienteId;
    setUrlPagamentoVenda(newURL);
  }, []);
  const onCopyLinkPagamento = () => {
    setLinkPagamentoCopiado(true);
  };
  return (
    <>
      <Subtitle>Copie o link para pagamento.</Subtitle>
      <LinkPagamento>
        <ContentLink>{urlPagamentoVenda}</ContentLink>
        <CopyToClipboard text={urlPagamentoVenda} onCopy={onCopyLinkPagamento}>
          <ButtonCopy>
            <CopyIcon />
          </ButtonCopy>
        </CopyToClipboard>
      </LinkPagamento>

      {linkPagamentoCopiado && (
        <div>
          <MensagemLinkPagamento>
            Link copiado para a área de transferência.
          </MensagemLinkPagamento>
        </div>
      )}
    </>
  );
};

export default CartaoLink;

const Row = styled.div`
  display: flex;
  gap: 5px;
`;
const Subtitle = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;
const LabelField = styled.label`
  color: #868686;
  font-size: 12px;
  height: 16px;
`;

const ContentCartao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  width: 160px;
  height: 40px;
  background-color: #505050;
  border-radius: 100px;
  border: 2px solid rgba(220, 220, 220, 0.2);
  gap: 8px;
  justify-content: space-between;
  padding: 0 16px;
  color: #fff;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  ${(props) => props.disabled && 'opacity: 0.5'};
`;

const LabelButton = styled.label`
  font-weight: 600;
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const MensagemLinkPagamento = styled.div`
  color: #505050;
  justify-content: center;
  font-size: 1rem;
`;

const LinkPagamento = styled.div`
  background-color: #f2f2f2;
  border-radius: 8px;
  border: 1px solid #dcdcdc33;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 4px;
  height: 32px;
  justify-content: space-between;
  width: 100%;
`;

const ButtonCopy = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

const ContentLink = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;
